import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";

const baseUrl = "https://api.shabdtoday.com/";
const online = "https://api.shabdtoday.com/api/home/getwebStorie";

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

const TajaKhabarCard = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=8`);

      if (response.data && response.data.webstory.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.webStoriesId));
          const newNews = response.data.webstory.filter(
            (item) => !existingIds.has(item.webStoriesId)
          );
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (err) {
      console.error("Error fetching news:", err.message);
      setError("डेटा लोड करने में समस्या हुई।");
    }
    setFetching(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);

  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    let hour = date.getHours();
    const minute = date.getMinutes();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {/* <Circles height="30" width="30" color="#f7265c" ariaLabel="loading" visible={true} /> */}
      </div>
    );
  }

  if (error) {
    return <div style={{ textAlign: "center", color: "red" }}>{error}</div>;
  }

  return (
    <div>
      <section className="container">
        <div className="wdgt-hdng mt-2">
          <h1 className="head">
            <Link
              to="/Webstorie-News"
              title="वेब स्टोरीज"
              aria-label="वेब स्टोरीज"
            >
              वेब स्टोरीज
            </Link>
          </h1>
        </div>

        <ul className="web-stry" id="webStories">
          {news.length > 0 ? (
            news.map((newsItem) => (
              <li key={newsItem.webStoriesId}>
                <Link
                  to={`/WebStrorie-News/${newsItem.webStoriesId}`}
                  title={newsItem.webStoryThumbNail_Heading}
                  target="_blank"
                >
                  <img
                    src={baseUrl + "/" + newsItem.webStoryThumbNail_Image}
                    width={150}
                    height={300}
                    alt={newsItem.webStoryThumbNail_Heading}
                    title={newsItem.webStoryThumbNail_Heading}
                  />
                  <div className="web-stry-cnt">
                    <h6>{stripHtmlTags(newsItem.webStoryThumbNail_Heading, 60)}</h6>
                    <div className="date">{formatDateInHindi(newsItem.added_Date)}</div>
                  </div>
                </Link>
              </li>
            ))
          ) : (
            <p
              style={{
                textAlign: "center",
                fontSize: "16px",
                color: "gray",
                marginTop: "20px",
              }}
            >
              कोई डेटा उपलब्ध नहीं है
            </p>
          )}

          <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
            {fetching && <p>Loading more stories...</p>}
            {!hasMore && news.length > 0 && <p>सब वेब स्टोरीज लोड हो चुकी हैं</p>}
          </div>
        </ul>
      </section>
    </div>
  );
};

export default TajaKhabarCard;
